import BasePopUpLayer from "../../../engines/components/BasePopUpLayer";
import O1HD from "../../../engines/gameEngine";
import { MessageEventKind } from "../../../modes/define/MessageEventKind";
import { TaskKind } from "../../../modes/define/TaskKind";
import NormalGameManager from "../../../modes/normalMode/manager/NormalGameManager";

const {ccclass, property} = cc._decorator;


const c_talk = [
    "谢谢你上次救了我，你能不能再帮帮我",
    '有个华贵妃喜欢在河边丛林打猎，我不小心被猎捕，折损了一支翅膀，变成了羽扇',
    '你能帮我找回我的翅膀吗？',
];
@ccclass
export default class healBeriberiStartPage extends BasePopUpLayer {

    @property({type:cc.Node,tooltip:"对话节点"})
    chatNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"按钮layout1"})
    btnLayout1:cc.Node = null;
    @property({type:cc.Node,tooltip:"按钮layout2"})
    btnLayout2:cc.Node = null;

    private curTalkIdx = -1;

    start(){
        this.btnLayout1.active = false;
        this.btnLayout2.active = false;
        this.chatNode.active = false;

        O1HD.getModules().uiControlModule.hideLoading();
        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.agreeCupidHelp2) {
            this.curTalkIdx = 0;
        }
    }

    onBtnNotSave(){
        this.node.destroy();
    }

    onBtnSave(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.btnLayout1.active = false;

        let gameData = NormalGameManager._instance.getGameData();
        gameData.agreeCupidHelp2 = true;
        NormalGameManager._instance.writeGameData();

        NormalGameManager._instance.taskDataManage.addNewTask(TaskKind.TaskId.TASK_7);

        O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);

        this.onClickPeople();
        // O1HD.getModules().uiControlModule.showLoading();
        // utilsView.openPopupLayerTwo(
        //     FileKind.PrefabFilePath.healBeriberiGameLayer,null,null,null,()=>{
        //         this.node.destroy();
        //     }
        // );
        
    }

    async onClickPeople(){
        if (this.curTalkIdx >= c_talk.length-1) {
            return;
        }

        if ( this.btnLayout1.active ||  this.btnLayout2.active) {
            return;
        }

        this.curTalkIdx++;
        switch(this.curTalkIdx) {
            case 0: {
                this.btnLayout1.active = true;
            }
            break;
            case 2: {
                this.btnLayout2.active = true;
            }
            break;
        }
        this.showOneChat(true, c_talk[this.curTalkIdx], 5);
        this.unschedule(this.onClickPeople);
        this.scheduleOnce(this.onClickPeople, 5);
    }

    async showOneChat(showOrHide:boolean,chat?:string,delayTime:number = 5){
        cc.Tween.stopAllByTarget(this.chatNode);
        return new Promise<void>(resolve=>{
            if(showOrHide){
                this.chatNode.active = true;
                this.chatNode.scale = 0;
                let lbChat:cc.Label = this.chatNode.getChildByName("label").getComponent(cc.Label);
                lbChat.string = chat;
                cc.tween(this.chatNode).to(0.2,{scale:1},{easing:cc.easing.backOut}).delay(delayTime).call(async ()=>{
                    await this.showOneChat(false);
                    resolve();
                }).start();
            }else{
                this.chatNode.active = true;
                this.chatNode.scale = 1;
                cc.tween(this.chatNode).to(0.2,{scale:0},{easing:cc.easing.backIn}).call(resolve).start();
            }
        });
    }

    onBtnBack(){
        this.node.destroy();
    }

}
